/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EServicePlace = 'AtRepairshop' | 'AtCustomerSite' | 'All';

export const EServicePlace = {
    AtRepairshop: 'AtRepairshop' as EServicePlace,
    AtCustomerSite: 'AtCustomerSite' as EServicePlace,
    All: 'All' as EServicePlace
};

